import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import Itrequestform from './Itrequestform';
import Footer from './Footer';
import DocumentAreroBanner from './DocumentAreroBanner';
import AerospaceDocumentDatatabs from './AerospaceDocumentDatatabs';
import AerospaceDoceumentSEeconddata from './AerospaceDoceumentSEeconddata';

const Documentaerospacepage = () => {
  const location = useLocation();
  const firstContentRef = useRef(null); // Reference for the first content (AerospaceDocumentDatatabs)
  const secondContentRef = useRef(null); // Reference for the second content (AerospaceDoceumentSEeconddata)
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);
  
  // Function to scroll to the first content dynamically
  const scrollToFirstContent = () => {
    if (firstContentRef.current) {
      const offset = 0; // Adjust this to control margin
      const elementPosition = firstContentRef.current.offsetTop; // Absolute position from the top of the page
      window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
    }
  };

  // Function to scroll to the second content dynamically
  const scrollToSecondContent = () => {
    if (secondContentRef.current) {
      const offset = 100; // Adjust this to control margin
      const elementPosition = secondContentRef.current.offsetTop; // Absolute position from the top of the page
      window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
    }
  };

  // The useEffect to handle hash-based scroll
  useEffect(() => {
    if (location.hash === "#AerospaceDoceumentSEeconddata") {
      setTimeout(() => {
        scrollToSecondContent();
      }, 500); // Delay ensures smooth scrolling after page load
    } else if (location.hash === "#AerospaceDocumentDatatabs") {
      setTimeout(() => {
        scrollToFirstContent();
      }, 500); // Delay ensures smooth scrolling after page load
    }
  }, [location]); // Re-run when location (URL) changes

  return (
    <div style={{ background: '#fff' }}>
      <DocumentAreroBanner />

      {/* First content with reference to scroll */}
      <div ref={firstContentRef} id="AerospaceDocumentDatatabs">
        <AerospaceDocumentDatatabs />
      </div>

      {/* Second content with reference to scroll */}
      <div ref={secondContentRef} id="AerospaceDoceumentSEeconddata">
        <AerospaceDoceumentSEeconddata />
      </div>

      <br />
      <Itrequestform />

      <div style={{ marginTop: "-60px" }}>
        <Footer />
      </div>

      {/* <style>
        {`
          h1,h2,h3,h4,h5,h6,p {
            font-family: urbanist, serif;
          }
        `}
      </style> */}
      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  );
};

export default Documentaerospacepage;
